import apiInstance from "@services/Shared/instanceAxios";

const getClients = () =>
  apiInstance({
    url: "/clients/",
  });

export default getClients;
